<template>
  <svg
    width="62"
    height="86"
    viewBox="0 0 62 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.5768 60.1631C42.935 59.1158 43.718 58.2758 44.6999 57.765C54.504 52.6659 61.2 42.4149 61.2 30.6C61.2 13.7001 47.4999 0 30.6 0C13.7001 0 0 13.7001 0 30.6C0 42.7497 7.08089 53.2456 17.341 58.1861C18.3804 58.6865 19.2137 59.5507 19.5872 60.6421L27.2154 82.9382C28.4494 86.545 33.5506 86.545 34.7846 82.9382L42.5768 60.1631Z"
      :fill="isActive ? '#E6362C' : '#646464'"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isActive: Boolean,
  },
};
</script>



// WEBPACK FOOTER //
// Content/src/components/MyProgress/Daccord/Flag.vue